"use strict";

import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { PagerComponent } from "./pager.component";

/**
 * XXX: currently need ng6 module as well as ng1 module
 */
@NgModule({
  imports: [CommonModule],
  exports: [PagerComponent],
  declarations: [PagerComponent]
})
export class PagerModule {}
